import theme from 'styled-theming';
import { darken, lighten } from 'polished';
export const colorBackground = theme('mode', {
  light: 'white',
  dark: '#232329'
});
export const colorBackgroundBody = theme('mode', {
  light: '#f2f4f7',
  dark: '#2a2a31'
});
export const inboxButtonBackground = theme('mode', {
  light: '#f2f4f7',
  dark: '#2a2a31'
});
export const inboxButtonBackgroundHover = theme('mode', {
  light: darken(0.05, '#f2f4f7'),
  dark: lighten(0.05, '#2a2a31')
});
export const colorHeaderDataPicker = theme('mode', {
  light: '#6db0ff',
  dark: '#063263'
});
export const colorText = theme('mode', {
  light: '#646777',
  dark: '#dddddd'
});
export const colorDarkText = theme('mode', {
  light: '#555555',
  dark: '#dddddd'
});
export const colorTextAdditional = theme('mode', {
  light: '#646777',
  dark: '#999999'
});
export const logoImg = theme('mode', {
  light: `url(${process.env.PUBLIC_URL}/img/logo/logo_light.png)`,
  dark: `url(${process.env.PUBLIC_URL}/img/logo/logo_dark.svg)`
});
export const colorHover = theme('mode', {
  light: '#fafbfe',
  dark: '#38373f'
});
export const colorFolderHover = theme('mode', {
  light: '#f0eeee',
  dark: '#ffffff1A'
});
export const colorBorder = theme('mode', {
  light: '#eff1f5',
  dark: '#333246'
});
export const colorIcon = theme('mode', {
  light: '#dddddd',
  dark: '#605f7b'
});
export const imgInvert = theme('mode', {
  light: 'invert(0%)',
  dark: 'invert(100%)'
});
export const colorFieldsBorder = theme('mode', {
  light: '#f2f4f7',
  dark: '#33333a'
});
export const colorBubble = theme('mode', {
  light: 'rgba(242, 244, 247, 0.65)',
  dark: 'rgba(68, 79, 97, 0.65)'
});
export const colorBubbleActive = theme('mode', {
  light: 'rgba(234, 238, 255, 0.6)',
  dark: 'rgba(92, 104, 156, 0.6)'
});
export const colorScrollbar = theme('mode', {
  light: '#B4BFD0',
  dark: '#606071'
});
export const colorFitness = theme('mode', {
  light: '#646777',
  dark: '#ffffff'
});
export const colorEmoji = theme('mode', {
  light: '#232329',
  dark: '#ffffff'
});
export const sidebarColor = theme('mode', {
  light: 'aliceblue',
  dark: '#232329'
}); // Cores principais extraídas da logo

export const colorAccent = '#233980'; // Azul escuro da logo (já estava correto)

export const colorLightAccent = '#3452b3'; // Azul mais claro, para hover/destaques

export const colorTbRed = '#e81920'; // Vermelho vibrante da logo

export const colorAccentHover = darken(0.1, colorAccent);
export const colorAdditional = '#6b6b6b'; // Cinza neutro mais escuro para contraste

export const colorAdditionalHover = darken(0.1, colorAdditional); // Amarelo, Verde, Violeta e demais cores de apoio (opcional)
// Pode remover se não usar no layout

export const colorYellow = '#ffd100'; // Amarelo inspirado nos detalhes do TB

export const colorLightYellow = '#fff6cc';
export const colorYellowHover = darken(0.1, colorYellow);
export const colorViolet = '#a399ff'; // Lilás azulado, harmonizando com azul TB
// Vermelhos de apoio

export const colorRed = '#e81920'; // Mesmo do TB, para uniformizar

export const colorDarkRed = '#ad131b'; // Vermelho escuro (shadows, bordas)

export const colorLightRed = '#f76c7d'; // Vermelho claro para notificações

export const colorVeryLightRed = '#fae3e5';
export const colorRedHover = darken(0.1, colorRed); // Azuis complementares

export const colorBlue = '#2456a2'; // Azul médio extraído do TB do logo

export const colorLightBlue = '#437be8'; // Azul claro do gradiente

export const colorBlueHover = darken(0.1, colorBlue); // Tons neutros

export const colorBlack = '#181e2a'; // Quase preto, mais elegante e menos agressivo

export const colorGray = '#a7aabd';
export const colorLightGray = '#e5e8ef';
export const colorDustyWhite = '#f7f8fa';
export const colorWhite = '#ffffff'; // Verdes (opcional)

export const colorGreen = '#85db81';
export const colorGreenHover = darken(0.1, colorGreen); // Cores de fundo, textos, etc

export const colorDarkFieldsBorder = '#233980'; // Usar azul TB para bordas

export const colorBlackBackground = '#222943'; // Azul escuro, não puro preto

export const colorLightText = '#4b5068'; // Azul acinzentado, suave
// Landing page, gradientes, botões

export const landingAccentColor = '#233980';
export const landingButtonColor = '#e81920';
export const landingSaffronColor = '#ffd100';
export const landingGradient = 'linear-gradient(228deg, #3452b3, #233980)';
export const landingGradientColor = 'linear-gradient(228deg, darken(#3452b3, 5%), darken(#233980, 5%))';
export const landingGradientBtn = 'linear-gradient(228deg, #e81920, #233980)';
export const landingGradientBtnHover = 'linear-gradient(228deg, darken(#e81920, 5%), darken(#233980, 5%))';
export const scrollbarStyles = props => `
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    opacity: 0.3;
  }
  
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    border: 1px solid transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: ${colorScrollbar(props)};
  }   
`;